<template>
  <div>
    <ApplicationsEmptyState v-if="currentTabApplications.length === 0" :currentTab="currentTab" />
    <div v-else>
      <div class="my-16 mx-10">
        <Dropdown id="sort-dropdown" v-model="sortByData" labelName="Sort by" :options="dropdownOptions" />
      </div>
      <ColumnTips
        v-if="currentTab !== 'NOT_A_FIT'"
        :currentTab="currentTab"
        :numberOfApplicants="currentTabApplications.length"
      />
      <ul class="sitter-list mt-16 md:mt-0">
        <li
          v-for="{ id, sitter, distance, createdAt, matchSummary } in currentTabApplications"
          :id="id"
          :key="id"
          :class="selectedApplicationUuid === id ? 'selected-application' : ''"
          class="w-full shadow-none md:border-b-1 border-grey-divider-subdued border-solid rounded-none first:md:border-t-1 last:-mb-1 px-16 pb-16 md:p-0"
        >
          <button class="inner-focus inline-block w-full" @click="navigateToApplication(id)">
            <ApplicantCard
              :careType="careType"
              :name="sitter.displayName"
              :customClasses="`w-full md:shadow-none ${selectedApplicationUuid === id ? 'bg-grey-background-contrast' : ''}`"
              :distance="distance === 0 ? 0.001 : distance"
              :location="sitter.location"
              :maxRate="sitter.careTypeDetails?.[camelCaseCareType]?.maxPayRate"
              :minRate="sitter.careTypeDetails?.[camelCaseCareType]?.minPayRate"
              :lastLogin="sitter.lastLogin"
              :createdAt="createdAt"
              :avatarPhotoUrl="sitter.photoUrl"
              :matchStrength="matchSummary?.strength"
            />
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import ApplicationsEmptyState from './ApplicationsEmptyState.vue';
import ColumnTips from '../ReplyContainer/ColumnTips.vue';
import ApplicantCard from './ApplicantCard.vue';
import Dropdown from '@/components/dropdown/Dropdown.vue';

export default {
  name: 'ApplicantList',
  components: {
    ApplicationsEmptyState,
    ColumnTips,
    ApplicantCard,
    Dropdown,
  },
  props: {
    currentTabApplications: {
      required: true,
      type: Array<{ id: string; sitter: any }>,
    },
    navigateToApplication: {
      required: true,
      type: Function,
    },
    currentTab: {
      type: String,
      required: true,
    },
    careType: {
      type: String,
      required: true,
    },
    sortBy: {
      type: String,
      default: 'RECENT',
    },
  },
  data() {
    return {
      sortByData: this.sortBy,
      dropdownOptions: [
        { display: 'Most Recent', value: 'RECENT' },
        { display: 'Closest', value: 'DISTANCE' },
      ],
    };
  },
  computed: {
    isNotAFit(): boolean {
      return this.$store.getters['applications/applicationDetails'].parentInterestStatus === 'NOT_A_FIT';
    },
    selectedApplicationUuid(): string {
      return this.$route.params.application_uuid;
    },
    camelCaseCareType(): string {
      let { careType } = this;
      if (this.careType === 'SPECIAL_NEEDS') {
        careType = 'BABYSITTER';
      }
      // convert careType prop into camelCase
      return careType.toLowerCase().replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
    },
  },
  watch: {
    sortByData(newVal) {
      this.$emit('sortChanged', newVal);
    },
    sortBy(newVal) {
      if (this.sortByData !== newVal) {
        this.sortByData = newVal;
      }
    },
  },
};
</script>
